import React from "react";
import "./Privacy_Policy.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faDesktop,
  faLocationDot,
  faUser,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const handleScroll = (id) => {
    const container = document.querySelector(".terms-content");
    const section = document.getElementById(id);

    if (container && section) {
      const containerTop = container.getBoundingClientRect().top;
      const sectionTop = section.getBoundingClientRect().top;

      const offset = 20; // 30px margin from top

      container.scrollTo({
        top: container.scrollTop + (sectionTop - containerTop) - offset,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <section className="privacy-header terms-header  container">
        <h1>PRIVACY POLICY</h1>
        <p>
          Effective Date: January 14, 2026. Your data security is our top
          priority.
        </p>
      </section>

      <section className="privacy-wrapper terms-wrapper">
        <aside className="terms-sidebar">
          <div className="jump-box">
            <h3>Jump to Sections</h3>
            <p>Quick Navigation</p>
            <ul>
              <li onClick={() => handleScroll("introduction")}>
                1. Introduction
              </li>
              <li onClick={() => handleScroll("data-collection")}>
                2. Data Collection
              </li>
              <li onClick={() => handleScroll("usage-of-data")}>
                3. Usage of Data
              </li>
              <li onClick={() => handleScroll("security-measures")}>
                4. Security Measures
              </li>
              <li onClick={() => handleScroll("payments")}>5. User Rights</li>
              <li onClick={() => handleScroll("disclaimer")}>
                6. Cookies Policy
              </li>
            </ul>
          </div>

          <div className="need-help-box">
            <h4>Need help?</h4>
            <p>Our support team is available 24/7 for legal inquiries.</p>
            <button onClick={() => navigate("/contactus")}>Contact Us</button>
          </div>
        </aside>

        <div className="terms-content">
          <div id="introduction" className="terms-section">
            <h2>
              <span>1.</span> Introduction
            </h2>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
            </p>

            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged.
            </p>
          </div>

          <div id="data-collection" className="terms-section">
            <h2>
              <span>2.</span> Data Collection
            </h2>

            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged.
            </p>

            <div className="row g-3 mt-3">
              <div className="col-md-6">
                <div className="data-card">
                  <div className="icon-holder">
                    <FontAwesomeIcon icon={faUser} />
                  </div>
                  <div className="card-content">
                    <h4>Personal Data</h4>
                    <p>Name, email address, phone number and date of birth.</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="data-card">
                  <div className="icon-holder">
                    <FontAwesomeIcon icon={faWallet} />
                  </div>
                  <div className="card-content">
                    <h4>Financial Data</h4>
                    <p>
                      Payment details, transaction history and wallet balance.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="data-card">
                  <div className="icon-holder">
                    <FontAwesomeIcon icon={faLocationDot} />
                  </div>
                  <div className="card-content">
                    <h4>Geolocation</h4>
                    <p>To ensure compliance with local betting regulations.</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="data-card">
                  <div className="icon-holder">
                    <FontAwesomeIcon icon={faDesktop} />
                  </div>
                  <div className="card-content">
                    <h4>Device Information</h4>
                    <p>IP address, browser type and app version.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="usage-of-data" className="terms-section">
            <h2>
              <span>3.</span> Usage of Data
            </h2>

            <ul className="usage-list">
              <li>
                <span className="tick-icon">
                  <FontAwesomeIcon icon={faCheck} />
                </span>
                <p>
                  <strong>Account Management:</strong> To create and manage your
                  betting account and process your withdrawals and deposits.
                </p>
              </li>

              <li>
                <span className="tick-icon">
                  <FontAwesomeIcon icon={faCheck} />
                </span>
                <p>
                  <strong>Fraud Prevention:</strong> To monitor for suspicious
                  activity and protect the integrity of the 11 Dreams platform.
                </p>
              </li>

              <li>
                <span className="tick-icon">
                  <FontAwesomeIcon icon={faCheck} />
                </span>
                <p>
                  <strong>Legal Compliance:</strong> To comply with Anti-Money
                  Laundering (AML) and Know Your Customer (KYC) requirements.
                </p>
              </li>

              <li>
                <span className="tick-icon">
                  <FontAwesomeIcon icon={faCheck} />
                </span>
                <p>
                  <strong>Personalisation:</strong> To provide you with tailored
                  cricket tips and promotional offers based on your activity.
                </p>
              </li>
            </ul>
          </div>

          <div id="security-measures" className="terms-section">
            <h2>
              <span>4.</span> Security Measures
            </h2>

            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged.
            </p>

            <div className="security-list">
              <div className="security-item">
                <img
                  src="/assets/images/contact-us/encrypted.png"
                  alt="Encryption"
                />
                <div>
                  <h4>End-to-End Encryption</h4>
                  <p>
                    All data transmitted between your device and our servers is
                    encrypted.
                  </p>
                </div>
              </div>

              <div className="security-item">
                <img
                  src="/assets/images/contact-us/privacy-page.png"
                  alt="Access Control"
                />
                <div>
                  <h4>Access Controls</h4>
                  <p>
                    Access to user data is strictly limited to authorized
                    personnel with a clear business need.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div id="payments" className="terms-section">
            <h2>
              <span>5.</span> User Rights
            </h2>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
            </p>

            <ul>
              <li>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </li>
              <li>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </li>
              <li>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </li>
              <li>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </li>
              <li>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </li>
            </ul>
          </div>

          <div id="disclaimer" className="terms-section">
            <h2>
              <span>6.</span> Cookies Policy
            </h2>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged.
            </p>
          </div>
        </div>
        <div className="need-help-box-mobile">
          <h4>Need help?</h4>
          <p>Our support team is available 24/7 for legal inquiries.</p>
          <button onClick={() => navigate("/contactus")}>Contact Us</button>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
